// src/app/AppRoutes.jsx
import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";

const Home = lazy(() => import("../pages/Home/Home"));
// Keep these existing pages as-is for now; we’ll revamp next:
const Contact = lazy(() => import("../pages/Contact/Contact"));   // your existing path
const Privacy = lazy(() => import("../pages/Privacy/Privacy"));   // your existing path

function Loader() {
  return (
    <Box sx={{ minHeight: "60vh", display: "grid", placeItems: "center" }}>
      <CircularProgress />
    </Box>
  );
}

export default function AppRoutes() {
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route path="/" element={<Home />} />

        {/* Keep your existing routes */}
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />

        {/* Placeholder: we will add this page next */}
        {/* <Route path="/web/home/public/chat" element={<PublicFrontdeskChat />} /> */}
      </Routes>
    </Suspense>
  );
}
